import "core-js/modules/es.array.reverse.js";
var _class;
import "core-js/modules/es.symbol.description.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, runInAction, makeObservable } from "mobx";
import combine from "terriajs-cesium/Source/Core/combine";
import isDefined from "../../Core/isDefined";
import omit from "lodash-es/omit";
let FunctionParameter = (_class = class FunctionParameter {
  constructor(catalogFunction, options) {
    this.catalogFunction = catalogFunction;
    _defineProperty(this, "isFunctionParameter", true);
    _defineProperty(this, "type", void 0);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "isRequired", void 0);
    makeObservable(this);
    this.id = options.id;
    this.name = options.name || this.id;
    this.description = options.description || "";
    this.isRequired = options.isRequired || false;
  }
  get isValid() {
    if (!isDefined(this.value)) {
      return !this.isRequired;
    }
    return true;
  }
  get value() {
    var _this$catalogFunction;
    return (_this$catalogFunction = this.catalogFunction.parameters) === null || _this$catalogFunction === void 0 ? void 0 : _this$catalogFunction[this.id];
  }
  setValue(strataId, v) {
    if (isDefined(v)) {
      let newParameters = {
        [this.id]: v
      };
      if (isDefined(this.catalogFunction.parameters)) {
        newParameters = combine(newParameters, this.catalogFunction.parameters);
      }
      runInAction(() => {
        this.catalogFunction.setTrait(strataId, "parameters", newParameters);
      });
    } else {
      this.clearValue(strataId);
    }
  }
  clearValue(strataId) {
    var _this$catalogFunction2;
    if (isDefined((_this$catalogFunction2 = this.catalogFunction.parameters) === null || _this$catalogFunction2 === void 0 ? void 0 : _this$catalogFunction2[this.id])) {
      runInAction(() => {
        this.catalogFunction.setTrait(strataId, "parameters", omit(this.catalogFunction.parameters, this.id));
      });
    }
  }
  formatValueAsString(value) {
    value = isDefined(value) ? value : this.value;
    return isDefined(value) ? value.toString() : "-";
  }
  static isInstanceOf(obj) {
    return obj.isFunctionParameter;
  }
}, _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "value", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "value"), _class.prototype), _class);
export { FunctionParameter as default };